import { Api } from '../../../api';
import { useEffect, useState } from 'react';
import {
  EXPERT_PROFILE_STATUS_ENUM,
  EXPERT_PROFILE_WORKFLOW_STATUS,
  GENDER
} from '../../../utils/constants';
import {
  errorToast,
  getWorkflowStatusBgColorPeapExpert,
  successToast
} from '../../../utils/helper';
import Loader from '../../../component/common/Loader';
import RejectExpertPopup from '../../../component/common/modals/RejectExpertPopup';
import { Icons } from '../../../component/common/svgs';
import AutoExpandingTextarea from '../../../component/common/Input/AutoExpandingTextArea';
const PeapProfileDailog = ({ onClose, expertId, refetchList }) => {
  const [profileData, setProfileData] = useState(null);

  const [showTooltipExperience, setShowTooltipExperience] = useState(false);
  // const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [status, setStatus] = useState('');

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [tooltipVisible, setTooltipVisible] = useState(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(profileData.socialId);
      setTooltipVisible(true);
      setTimeout(() => setTooltipVisible(false), 1000);
    } catch (err) {
      console.error('Failed to copy: ', err);
      alert('Failed to copy LinkedIn URL.');
    }
  };

  const fetchProfileData = async (expertId) => {
    console.log('inside fetchProfileData', expertId);

    if (!expertId) return; // Don't fetch if no expertId

    setLoading(true);
    setError(null); // Reset error state before fetching
    try {
      const response = await Api.getPeapAccountInfo(expertId); // Await the API call
      setProfileData(response?.data?.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfileData(expertId);
  }, [expertId]);
  const formatDate = (isoDate) => {
    if (!isoDate) return '';

    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  };

  const getGenderName = (value) => {
    const genderItem = GENDER.find((g) => g.value === value);
    return genderItem ? genderItem.name : 'Not specified'; // Default if not found
  };

  // const handleApproveDBS = async () => {
  //   const payload = {
  //     id: profileData.id,
  //     profile_status: EXPERT_PROFILE_STATUS[3].value
  //   };
  //   Api.updatePeapExpertProfileStatus(payload)
  //     .then((response) => {
  //       if (response?.data?.meta?.code === 1) {
  //         successToast(response?.data?.meta?.message);
  //         setOpenConfirmModal(false);
  //         onClose();
  //         refetchList();
  //       } else {
  //         errorToast(response?.data?.meta?.message);
  //       }
  //     })
  //     .catch((error) => {
  //       errorToast(error);
  //     });
  // };
  const handleReject = (reason) => {
    const reqBody = {
      id: profileData.id,
      profile_status: status,
      reject_reason: reason
    };
    Api.updatePeapExpertProfileStatus(reqBody)
      .then((response) => {
        if (response?.data?.meta?.code === 1) {
          successToast(response?.data?.meta?.message);
          setOpenRejectModal(false);
          onClose();
          refetchList();
        } else {
          errorToast(response?.data?.meta?.message);
        }
      })
      .catch((error) => {
        errorToast(error);
      });
  };

  const genderValue = profileData?.gender ? getGenderName(profileData?.gender?.[0]) : 'N/A';

  const profileStatus = EXPERT_PROFILE_WORKFLOW_STATUS?.[profileData?.workflowSuccess]?.name;

  const dbsDoc = profileData?.expertAttachments?.find((item) => item.docType === 'dbs');
  const cvDoc = profileData?.expertAttachments?.find((item) => item.docType === 'cv');
  const otherDoc =
    profileData?.expertAttachments?.filter((item) => !['cv', 'dbs'].includes(item.docType)) || [];

  return (
    <>
      {/* {openConfirmModal && (
        <ConfirmPopup
          open={openConfirmModal}
          setOpen={setOpenConfirmModal}
          message={'Are you sure you want to approve?'}
          setAccepted={handleApproveDBS}
          handleNo={() => {
            setOpenConfirmModal(false);
          }}
        />
      )} */}
      <RejectExpertPopup
        open={openRejectModal}
        onClose={() => setOpenRejectModal(false)}
        onSubmit={handleReject}
        message="Are you sure you want to reject?"
      />
      <div
        className="profile-popup fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
        onClick={onClose}
      >
        <div
          className="bg-white rounded-3xl shadow-lg w-full max-w-[calc(100%-3rem)] p-4 xl:p-6 md:max-w-[80%] relative max-h-[90vh] overflow-y-auto no-scrollbar"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            className="text-black hover:text-gray-700 text-3xl absolute top-6 right-6 leading-none"
            onClick={onClose}
          >
            &times;
          </button>
          {loading && <Loader />}
          <div className="h-full">
            <div className="mb-4 md:mb-[50px]">
              <div className="text-2xl md:text-[40px] md:leading-[50px] font-medium text-[#0B1D2E] tracking-wide">
                {profileData?.name}
              </div>
              <div className="text-shoorah-gray8 text-base md:text-xl font-normal">
                Showing account information for {profileData?.name}
              </div>
            </div>
            <div className="max-h-[450px] sm:max-h-[500px] lg:max-h-[80vh] overflow-y-auto no-scrollbar">
              <div className="grid md:grid-cols-2 lg:grid-cols-5 xl:grid-cols-5 gap-4 xl:gap-6 items-center mb-6 xl:mb-8">
                <div className="row-span-3 xl:row-span-2 h-full min-h-[165px] bg-black rounded-2xl flex justify-center items-center">
                  {profileData?.userProfile ? (
                    <img
                      loading="lazy"
                      className="w-full h-full max-h-[300px] lg:max-h-[193px] object-cover rounded-2xl"
                      src={profileData?.userProfile}
                      alt="profile"
                    />
                  ) : (
                    <p className="text-white">No Image available</p>
                  )}
                </div>
                <div className="flex items-center justify-center min-h-[165px] row-span-3 xl:row-span-2 h-full max-h-[300px] lg:max-h-[193px] rounded-2xl bg-black overflow-hidden">
                  {profileData?.introVideo ? (
                    <video width="100%" height="100%" controls autoPlay muted loop>
                      <source src={profileData.introVideo} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <p className="text-white">No video available</p>
                  )}
                </div>
                <div className="col-span-1 justify-end headlessui-portal-rootitems-start">
                  <div className="opacity-50 text-black text-sm font-normal  leading-[14.50px] pb-1">
                    Title & name
                  </div>
                  <input
                    type="text"
                    className="bg-white text-sm font-medium rounded-[10px] text-black px-2 py-3 md:px-5 md:py-6 w-full leading-none border border-[#d9d9d9] truncate"
                    value={profileData?.name || 'N/A'}
                    disabled
                  />
                </div>
                <div className="col-span-1 justify-end items-start">
                  <div className="opacity-50 text-black text-sm font-normal  leading-[14.50px] pb-1">
                    Date of birth
                  </div>

                  <input
                    type="text"
                    className="bg-white text-sm font-medium rounded-[10px] text-black px-2 py-3 md:px-5 md:py-6 w-full leading-none border border-[#d9d9d9] truncate"
                    value={profileData?.dob ? formatDate(profileData?.dob) : 'N/A'}
                    disabled
                  />
                </div>
                <div className="col-span-1 justify-end items-start">
                  <div className="opacity-50 text-black text-sm font-normal  leading-[14.50px] pb-1">
                    Gender
                  </div>
                  <input
                    type="text"
                    className="bg-white text-sm font-medium rounded-[10px] text-black px-2 py-3 md:px-5 md:py-6 w-full leading-none border border-[#d9d9d9] truncate"
                    value={genderValue}
                    disabled
                  />
                </div>
                <div className="col-span-1  justify-end items-start">
                  <div className="opacity-50 text-black text-sm font-normal  leading-[14.50px] pb-1">
                    Ethnicity
                  </div>
                  <input
                    type="text"
                    className="bg-white text-sm font-medium rounded-[10px] text-black px-2 py-3 md:px-5 md:py-6 w-full leading-none border border-[#d9d9d9] truncate"
                    value={profileData?.ethnicity || 'N/A'}
                    disabled
                  />
                </div>
                <div className="col-span-1 justify-end items-start">
                  <div className="opacity-50 text-black text-sm font-normal  leading-[14.50px] pb-1">
                    Location
                  </div>
                  <input
                    type="text"
                    className="bg-white text-sm font-medium rounded-[10px] text-black px-2 py-3 md:px-5 md:py-6 w-full leading-none border border-[#d9d9d9] truncate"
                    value={profileData?.country || 'N/A'}
                    disabled
                  />
                </div>
              </div>
              <div className="grid lg:grid-cols-2 gap-4 xl:gap-8">
                <div className="left">
                  <p className="mb-3 text-black opacity-50 text-sm">Professional Experience</p>
                  <div className="grid md:grid-cols-2 gap-[20px] border rounded-xl border-[#D9D9D9] p-5">
                    <div>
                      <p className="text-black text-sm">Industry Experience:</p>
                      {profileData?.industryExperience?.length > 0 ? (
                        <>
                          <span className="font-medium">
                            {profileData?.industryExperience
                              ?.slice(0, 4)
                              .map((experience, index) => (
                                <span key={index} className="text-black text-sm">
                                  {experience}
                                  {index < 3 && <br />}{' '}
                                  {/* Add a line break between items except after the last one */}
                                </span>
                              ))}
                            {profileData?.industryExperience.length > 4 && (
                              <span
                                className="text-black text-sm cursor-pointer"
                                onMouseEnter={() => setShowTooltipExperience(true)} // Set to true on hover
                                onMouseLeave={() => setShowTooltipExperience(false)} // Set to false on mouse leave
                              >
                                ...
                              </span>
                            )}
                          </span>
                          {showTooltipExperience && (
                            <div className="tooltip">
                              <p>{profileData?.industryExperience.join(', ')}</p>
                            </div>
                          )}
                        </>
                      ) : (
                        <span className="font-medium">N/A</span>
                      )}
                    </div>
                    <div>
                      <p className="text-black text-sm">Years of experience:</p>
                      <p className="text-black text-sm">
                        <span className="font-medium">
                          {profileData?.yearOfExperience || 'N/A'}
                        </span>
                      </p>
                    </div>
                    <div>
                      <p className="text-black text-sm">Highest level of certification:</p>
                      <p className="text-black text-sm font-medium">
                        {profileData?.highestCertification || 'N/A'}
                      </p>
                    </div>

                    <div>
                      <p className="text-black text-sm">Specialties:</p>
                      <p className="text-black text-sm font-medium">
                        {profileData?.specialities
                          ?.map((specialty) => specialty.displayName)
                          .join(', ') || 'N/A'}
                      </p>
                    </div>
                    <div>
                      <p className="text-black text-sm">Qualifications:</p>
                      <p className="text-black text-sm font-medium">
                        {profileData?.qualification?.length
                          ? profileData?.qualification.join(', ')
                          : 'N/A'}
                      </p>
                    </div>
                    <div>
                      <p className="text-black text-sm">Availability:</p>
                      <p className="text-black text-sm font-medium">
                        {profileData?.availibility || 'N/A'}
                      </p>
                    </div>
                    <div>
                      <p className="text-black text-sm">Languages:</p>
                      <p className="text-black text-sm font-medium">
                        {profileData?.spokenLanguages?.join(', ') || 'N/A'}
                      </p>
                    </div>
                    <div>
                      <p className="text-black text-sm">Price per hour:</p>
                      <div className="flex gap-2 flex-col">
                        <p className="text-black text-sm font-medium">
                          £ {profileData?.pricePerHour || 'N/A'}
                        </p>
                        <div className="flex items-center gap-2">
                          <p className="text-sm font-medium text-shoorah-gray2">
                            Reject Price per hour?
                          </p>
                          <button
                            className=""
                            onClick={() => {
                              setOpenRejectModal(true);
                              setStatus(EXPERT_PROFILE_STATUS_ENUM.COST_REJECTED);
                            }}
                          >
                            <Icons.rejectCrossIcon className="w-5 h-5 text-red-500" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p className="text-black text-sm">Current job title:</p>
                      <p className="text-black text-sm font-medium">
                        {profileData?.jobTitle || 'N/A'}
                      </p>
                    </div>
                    <div>
                      <p className="text-black text-sm">Medical ID number:</p>
                      <p className="text-black text-sm font-medium">
                        {profileData?.medicalId || 'N/A'}
                      </p>
                    </div>
                    <div>
                      <p className="text-black text-sm">Place of education:</p>
                      <p className="text-black text-sm font-medium">
                        {profileData?.placeOfEducation || 'N/A'}
                      </p>
                    </div>
                    <div>
                      <p className="text-black text-sm">Place of practice:</p>
                      <p className="text-black text-sm font-medium">
                        {profileData?.locationOfPractice || 'N/A'}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="right ">
                  <div className="grid md:grid-cols-4 gap-4 xl:gap-6 gap-y-4 ">
                    <div className="">
                      <div className="opacity-50 text-black text-sm font-normal  mb-3">
                        DBC Document
                      </div>
                      <a
                        href={dbsDoc?.fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        download
                        className="bg-white text-sm font-medium rounded-[10px] text-black px-2 py-3 md:px-5 md:py-6 w-full leading-none border border-[#d9d9d9] block text-left"
                      >
                        View file
                      </a>
                      <div className="flex items-center justify-start gap-2 mt-2">
                        <p className="text-sm font-medium text-shoorah-gray2">Reject Dbs?</p>
                        <button
                          onClick={() => {
                            setOpenRejectModal(true);
                            setStatus(EXPERT_PROFILE_STATUS_ENUM.DBS_REJECTED);
                          }}
                        >
                          <Icons.rejectCrossIcon className="w-5 h-5 text-red-500" />
                        </button>
                        {/* <button onClick={() => setOpenConfirmModal(true)}>Approve</button> */}
                      </div>
                    </div>
                    <div className="">
                      <div className="opacity-50 text-black text-sm font-normal  mb-3">
                        ID Status
                      </div>
                      <input
                        type="text"
                        className={`text-sm font-medium rounded-[10px] max-h-[64px] px-2 py-3 md:px-5 md:py-6 w-full leading-none border border-[#d9d9d9] truncate ${getWorkflowStatusBgColorPeapExpert(
                          profileData?.workflowSuccess || 0
                        )}`}
                        value={profileStatus || 'N/A'}
                        disabled
                      />
                    </div>

                    <div>
                      <div className="opacity-50 text-black text-sm font-normal  mb-3">
                        LinkedIn URL
                      </div>
                      <div className="relative">
                        <input
                          type="text"
                          className="bg-white text-sm font-medium rounded-[10px] text-black max-h-[64px] px-2 py-3 md:px-5 md:py-6 w-full leading-none border border-[#d9d9d9] truncate cursor-pointer focus:outline-none"
                          value={profileData?.socialId || 'N/A'}
                          onClick={copyToClipboard}
                          // disabled
                          readOnly
                        />
                        {tooltipVisible && (
                          <div className="absolute left-0 top-full mt-1 bg-gray-700 text-white text-sm rounded px-2 py-1">
                            LinkedIn URL copied!
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="">
                      <div className="opacity-50 text-black text-sm font-normal  mb-3">Resume</div>
                      <a
                        href={cvDoc?.fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        download
                        className="bg-white text-sm font-medium rounded-[10px] text-black px-2 py-3 md:px-5 md:py-6 w-full leading-none border border-[#d9d9d9] block text-left"
                      >
                        View file
                      </a>
                    </div>
                    {otherDoc.map((doc, index, arr) => {
                      return (
                        <div key={doc.id}>
                          <div className="opacity-50 text-black text-sm font-normal capitalize mb-3">
                            {index + 1}. {doc.fileTitle.toLowerCase()}
                          </div>
                          <a
                            href={doc.fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                            title={doc?.fileName}
                            className="bg-white max-w-full truncate text-sm font-medium rounded-[10px] text-black px-2 py-3 md:px-5 md:py-6 w-full leading-none border border-[#d9d9d9] block text-left"
                          >
                            View File
                          </a>
                        </div>
                      );
                    })}
                  </div>
                  <div className="mt-2 flex mb-4 md:mb-6 items-center gap-2 justify-start text-start">
                    <p className="text-sm font-medium text-shoorah-gray2">Reject Documents?</p>
                    <button
                      className=""
                      onClick={() => {
                        setOpenRejectModal(true);
                        setStatus(EXPERT_PROFILE_STATUS_ENUM.INSURANCE_REJECTED);
                      }}
                    >
                      <Icons.rejectCrossIcon className="w-5 h-5 text-red-500" />
                    </button>
                  </div>
                  <div className="mb-4 md:mb-6">
                    <div className="opacity-50 text-black text-sm font-normal  leading-[14.50px] pb-1">
                      Personal bio
                    </div>
                    <AutoExpandingTextarea
                      className="bg-white text-sm font-medium rounded-[10px] text-black px-2 py-3 md:px-5 md:py-6 w-full leading-none border border-[#d9d9d9]"
                      value={profileData?.bio || 'N/A'}
                      disabled
                    />
                    {/* <textarea
                      className="bg-white text-sm font-medium rounded-[10px] text-black px-2 py-3 md:px-5 md:py-6 w-full leading-none border border-[#d9d9d9]"
                      name=""
                      id=""
                      value={profileData?.bio || 'N/A'}
                      disabled
                    ></textarea> */}
                  </div>
                  <div className="">
                    <div className="opacity-50 text-black text-sm font-normal  leading-[14.50px] pb-1">
                      Why they want to join PEAP?
                    </div>
                    <AutoExpandingTextarea
                      className="bg-white text-sm font-medium rounded-[10px] text-black px-2 py-3 md:px-5 md:py-6 w-full leading-none border border-[#d9d9d9]"
                      name=""
                      id=""
                      value={profileData?.reasonToJoin || 'N/A'}
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Modal Content */}
        </div>
      </div>
    </>
  );
};

export default PeapProfileDailog;
